(function () {
  'use strict';

  document.querySelectorAll('[data-age-finder]').forEach(function (root) {
    var tabs = root.querySelectorAll('[data-age-tab]');
    var panels = root.querySelectorAll('[data-age-panel]');

    function activate(idx) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-age-tab') === String(idx);
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        var on = p.getAttribute('data-age-panel') === String(idx);
        if (on) {
          p.hidden = false;
          // restart the pop animation
          p.querySelectorAll('.awita-age__card, .awita-age__media').forEach(function (el) {
            el.style.animation = 'none';
            void el.offsetWidth;
            el.style.animation = '';
          });
        } else {
          p.hidden = true;
        }
      });
    }

    root.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-age-tab]');
      if (!tab || !root.contains(tab)) return;
      activate(tab.getAttribute('data-age-tab'));
    });
  });
})();
